import { render, staticRenderFns } from "./otherBankInfoList.vue?vue&type=template&id=72b6d283&scoped=true"
import script from "./otherBankInfoList.vue?vue&type=script&lang=js"
export * from "./otherBankInfoList.vue?vue&type=script&lang=js"
import style0 from "./otherBankInfoList.vue?vue&type=style&index=0&id=72b6d283&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b6d283",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72b6d283')) {
      api.createRecord('72b6d283', component.options)
    } else {
      api.reload('72b6d283', component.options)
    }
    module.hot.accept("./otherBankInfoList.vue?vue&type=template&id=72b6d283&scoped=true", function () {
      api.rerender('72b6d283', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/credit/report/pdfDataInfo/mainCreditEvaluation/otherBankInfoList.vue"
export default component.exports